<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP推荐模块 新增/修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="200">
                            <Row :gutter="15">
                                <Col span="18">
                                    

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>圖片預覽</span>
                                        </div>
                                        <div class="form-upload-img">
                                            <!-- <div class="img-preview" v-if="uploadFile.base64"> -->
                                            <!--    <img style="width: 200px;" :src="form.image" alt="">-->
                                            <!-- </div> -->
                                            <el-image
                                                style="width: 200px;"
                                                :z-index="99999"
                                                :src="form.image_path"
                                                :preview-src-list="[form.image_path]">
                                            </el-image>
                                            <Upload :before-upload="handleBeforeUpload"
                                                    accept="image/png, image/jpg, image/jpeg"
                                                    action="">
                                                <div class="upload-btn">選擇圖片</div>
                                            </Upload>
                                            <div class="upload-tip">格式：PNG、JPG</div>
                                            
                                        </div>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>圖片上傳</span>
                                        </div>
                                        <Input v-model="form.image_path" style="width:100%" clearable/>
                                    </FormItem>
                                    
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <!--<em class="red">* </em>-->
                                            <span>跳轉鏈接</span>
                                        </div>
                                        <Input v-model="form.image_url" style="width:100%" clearable/>
                                    </FormItem>
                                    
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>狀態</span>
                                        </div>
                                        <RadioGroup v-model="form.image_staus">
                                            <Radio label="1">
                                                <span>是</span>
                                            </Radio>
                                            <Radio label="0">
                                                <span>否</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.sort" max="100" min="1" placeholder="1-100" clearable/>
                                    </FormItem>

                                </Col>
                            </Row>
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style2" @click="handleCheckForm">确认</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    import wangEditor from "wangeditor";

    export default {
        data() {
            return {
                uploadFile: {
                    file: '',
                    base64: '',
                },
                isSubmiting: false,
                pageParam: {},
                form: {
                    id: '',
                    c_id: '',
                    image_path: '',
                    image_url: '',
                    image_staus: '0',
                    sort: '',
                },
            };
        },
        created() {
            let pageParam  = this.pageParam = this.$route.query;
            this.form.c_id = pageParam?.pid;
            pageParam.type == 1 && this.getDetail()
        },
        methods: {
            
            // 列表
            getDetail() {
                this.$Rq.requestAuth({
                    url: this.$Api.appRecommendedManageList,
                    method: 'get',
                    data: {
                        id: this.pageParam.pid,
                        image_id: this.pageParam.cid
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.form = res.data.data[0]?.carousel_info[0];
                        this.form.image_staus = this.form.image_staus.toString()
                    }
                });
            },
        
            // 检查
            handleCheckForm() {
                let form = this.form;
            
                if (!form.image_path) {
                    this.$Utils.showTipInfo('請輸入圖片上傳');
                    return;
                }
                if (form.sort === '') {
                    this.$Utils.showTipInfo('請輸入排序');
                    return;
                }
                if (form.image_staus === '') {
                    this.$Utils.showTipInfo('請輸入狀態');
                    return;
                }
                this.handleSubmit();
            },
        
            // 确定
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;
                let url,data;
                if (this.pageParam.type == 0) { // 新增
                    url = this.$Api.appRecommendedChildAdd
                    data = form
                }else { // 修改
                    url = this.$Api.appRecommendedEditImg
                    data = {
                        image_id: form.id,
                        image_path: form.image_path,
                        image_url: form.image_url,
                        sort:form.sort,
                        image_staus: form.image_staus
                    }
                }
                
                this.$Rq.requestAuth({
                    url,
                    method: 'post',
                    data
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showSuccess(res.msg);
                    if (res.code == 0) {
                        if (this.pageParam.type == 0) {
                            this.removeForm()
                        }else {
                            this.getDetail()
                        }
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
    
            // 清除
            removeForm() {
                this.form = {
                    c_id: this.form.c_id,
                    image_path: '',
                    image_url: '',
                    image_staus: '0',
                    sort: '',
                }
            },
    
            //上传
            handleBeforeUpload(file){
                this.uploadFile.file = file;
                this.hanldeImgToBase64();
                return false;
            },
            hanldeImgToBase64() {
                let file = this.uploadFile.file;
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    let _base64 = reader.result;
                    this.uploadFile.base64 = _base64;
                };
                this.handleUploadImg();
            },
            handleUploadImg() {
                this.isSubmiting = true;
                let formData = new FormData();
                formData.append('file', this.uploadFile.file);
                this.$Rq.requestAuth({
                    url: this.$Api.uploadImg,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showTipInfo(res.msg);
                    if (res.code == 0) {
                        this.form.image_path = res.data.app_url;
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
    
            handleBack() {
                this.$router.go(-1);
            },
        }
    };
</script>
<style>
.el-tree-node > .el-tree-node__children {
    max-height: 500px;
    overflow-y: auto;
}
</style>
<style lang="scss" scoped>
    @import "recommendedEdit.scss";
</style>
